import React, { useRef } from 'react';
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Camera, X } from "lucide-react";

export const PhotoPicker = ({ photos, onChange, max = 10 }) => {
  const inputRef = useRef(null);
  const add = (e) => {
    const picked = Array.from(e.target.files || []).filter((f) => f.type.startsWith('image/'));
    onChange([...photos, ...picked].slice(0, max));
    e.target.value = '';
  };
  return (
    <div className="space-y-3">
      <Label>Photos ({photos.length}/{max})</Label>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
        {photos.map((f, i) => (
          <div key={i} className="relative aspect-square rounded-lg overflow-hidden bg-stone-100" data-testid={`incident-photo-preview-${i}`}>
            <img src={URL.createObjectURL(f)} alt="" className="w-full h-full object-cover" />
            <button type="button" onClick={() => onChange(photos.filter((_, idx) => idx !== i))} className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-1" data-testid={`incident-photo-remove-${i}`}>
              <X className="w-3 h-3" />
            </button>
          </div>
        ))}
        {photos.length < max && (
          <Button type="button" variant="outline" onClick={() => inputRef.current?.click()} className="aspect-square h-auto flex flex-col gap-1 border-dashed" data-testid="incident-add-photo-btn">
            <Camera className="w-6 h-6 text-stone-500" />
            <span className="text-xs">Add photo</span>
          </Button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple className="hidden" onChange={add} data-testid="incident-photo-input" />
    </div>
  );
};
